export default {
  clientType: [],
  clientAuditData: {},
  clientAuditDetail: {},
  auditContacts: {},
};
